module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="WWresortName">'+
((__t=( name ))==null?'':__t)+
'</span>';
}
return __p;
};
